import { useRef, useState } from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { descargarPlantillaExcel, filasComoObjetos, leerPrimeraHoja } from "../../utils/excelImport";

export default function ImportarExcelSimple({
  headers,
  filaEjemplo = [],
  filename,
  titulo = "Importar desde Excel",
  ayuda,
  columnasObligatorias,
  onFilas,
}) {
  const inputRef = useRef(null);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const requeridas = columnasObligatorias || headers;

  const procesar = async (event) => {
    const archivo = event.target.files?.[0];
    event.target.value = "";
    if (!archivo) return;
    setMensaje("");
    setError("");
    setCargando(true);
    try {
      const rows = await leerPrimeraHoja(archivo);
      const { filas, error: parseError } = filasComoObjetos(rows, headers);
      if (parseError) {
        setError(parseError);
        return;
      }
      const validas = filas.filter((fila) =>
        requeridas.every((col) => String(fila[col] ?? "").trim() !== "")
      );
      const vacias = filas.length - validas.length;
      const resultado = await onFilas(validas);
      const importados = resultado?.importados ?? validas.length;
      const omitidos = (resultado?.omitidos ?? 0) + vacias;
      const partes = [];
      if (importados) partes.push(`${importados} importado(s)`);
      if (omitidos) partes.push(`${omitidos} omitido(s)`);
      setMensaje(partes.join(". ") + (partes.length ? "." : "No hay filas para importar."));
    } catch (e) {
      setError(e?.message || "No se pudo leer el archivo.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        {titulo}
      </Typography>
      {ayuda && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {ayuda}
        </Typography>
      )}
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<DownloadIcon />}
          onClick={() => descargarPlantillaExcel(headers, filaEjemplo, filename)}
        >
          Descargar plantilla
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<UploadFileIcon />}
          disabled={cargando}
          onClick={() => inputRef.current?.click()}
        >
          Subir Excel
        </Button>
      </Stack>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
        hidden
        onChange={procesar}
      />
      {mensaje && <Alert severity="success" sx={{ mt: 1.5 }}>{mensaje}</Alert>}
      {error && <Alert severity="warning" sx={{ mt: 1.5 }}>{error}</Alert>}
    </Box>
  );
}
